import { FLAGS } from '../../../../config/constants/images';

export const FLAGS_CONFIG = [
  /* {
    countryCode: 'ie',
    countryName: 'Ireland',
    flagImg: FLAGS.ireland,
    href: 'https://www.wowcher.ie',
  },*/
  {
    countryCode: 'gb',
    countryName: 'UK',
    flagImg: FLAGS.unitedKingdom,
    href: 'https://www.5pm.co.uk',
  },
];
